import { getDefaultStore } from 'jotai';
import { initGridSettingsFromStorage } from './gridSettingsAtom';

export const store = getDefaultStore();

// Initialize atoms from localStorage at module load time
try {
  initGridSettingsFromStorage();
} catch (error) {
  console.error('[store] Failed to initialize grid settings from storage:', error);
}
